<template>
  <main class="content">
    <slot name="content"></slot>
  </main>
  <div class="error-container">
    <transition-group name="fade" tag="div">
      <div
        v-for="error in errors"
        :key="error.id"
        :style="{
          marginTop: '10px',
          backgroundColor: error.color,
          color: 'white',
          padding: '10px 20px',
          borderRadius: '4px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)'
        }"
      >
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-html="error.msg"></div>
      </div>
    </transition-group>
  </div>
</template>
<script setup lang="ts">
import { provide, ref } from 'vue'
interface ErrorMessage {
  id: number
  msg: string
  color: string
}

type ShowError = (msg: string, color?: string, time?: number) => void

const errors = ref<ErrorMessage[]>([])
const showError: ShowError = (msg, color = 'red', time = 3000) => {
  const id = Date.now() + Math.random()
  errors.value.push({ id, msg, color })
  setTimeout(() => {
    errors.value = errors.value.filter((error) => error.id !== id)
  }, time)
}

provide<ShowError>('showError', showError)
</script>
<style>
.error-container {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99999999;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.button-text {
  background-color: transparent;
  justify-content: flex-start;
  display: flex;
}
.button-text span {
  flex: unset !important;
}
.content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
